<template>
  <div class="containerTable" style="padding:20px;">
    <vxe-toolbar
      id="toolbarId_as7"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('carrierContract_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('carrierContract_batchRebackSign_button')"
          @click="funcRebackSign(1)"
        >
          批量重新生成合同
        </el-button>
        <el-button
          v-if="getLimit('carrierContract_download_button')"
          @click="PDFDownload()"
        >
          批量下载合同
        </el-button>
        <el-button
          v-if="
            getLimit('carrierContract_batchReport_button') && loginkTarget == 13
          "
          @click="getSelectEvent()"
        >
          批量上报
        </el-button>
        <el-button
          v-if="getLimit('carrierContract_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :footer-method="footerMethod"
      :footer-cell-class-name="footerCellClassName"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人/车队名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人/车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人电话"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入实际承运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleName"
          title="车牌号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleName"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentPhone"
          title="托运人电话"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPhone"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="contractNo"
          title="合同编号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.contractNo"
            placeholder="请输入合同编号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="startAddress"
          title="出发地"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.startAddress"
            placeholder="请输入出发地"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="endAddress"
          title="目的地"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.endAddress"
            placeholder="请输入目的地"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="goodsType"
          title="货物"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.goodsType"
            placeholder="请输入货物"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSend"
          title="上报状态"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'isSend')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isSend" clearable placeholder="请选择">
            <el-option
              v-for="item in isSendOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="sendError"
          title="上报结果"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.sendError"
            placeholder="请输入上报结果"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="weight" title="货物重量" min-width="200" />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeeDeserved"
          title="金额"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeeDeservedStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeeDeservedEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSign"
          title="签章状态"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'isSign')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isSign" clearable placeholder="请选择">
            <el-option
              v-for="item in isSignOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('carrierContract_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.contractPath)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('carrierContract_sign_button') &&
                signType != 1 &&
                scope.row.isShowESignButton
            "
            class="item"
            effect="dark"
            content="电子签章"
            placement="top"
          >
            <vxe-button type="text" @click="funcSign(scope.row.code)">
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('carrierContract_sign_button') &&
                signType == 1 &&
                scope.row.isShowESignButton
            "
            class="item"
            effect="dark"
            content="电子签章"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => showModel(scope.row, 'Sms')"
            >
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('carrierContract_rebackSign_button')"
            class="item"
            effect="dark"
            content="重新生成合同"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcRebackSign(0, scope.row.orderDetailCode)"
            >
              <i class="el-icon-refresh-right" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('carrierContract_reportLogink_button') &&
                scope.row.detailIsSend == 1 &&
                scope.row.isSend != 1 &&
                loginkTarget == 13
            "
            class="item"
            effect="dark"
            content="上报"
            placement="top"
          >
            <vxe-button type="text" @click="reportLogink(scope.row.code)">
              <i class="el-icon-edit-outline" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-modal
      v-model="ModelSms"
      title="电子签章验证码"
      width="800"
      height="80%"
      resize
      @close="close"
    >
      <Sms ref="SmsRef" @hideModel="hideModel" />
    </vxe-modal>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
import {
  reportContractInfo,
  createContractAgain,
  downLoadFile
} from "@/api/transport";
import Sms from "./components/sms.vue";
export default {
  components: {
    Sms
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      value2: "",
      detailFlag: false,
      exportObj: {
        exportUrl:
          "/ntocc-basic-api/orderDetailContract/exportConsigneeContract", //导出接口
        name: "承运合同"
      },
      listQuery: {
        gmtCreatedRange: "",
        contractType: 0, //合同类型，0承运，1托运，默认0
        mainOrderNumber: "",
        orderCode: "",
        orderDetailCreatedName: "",
        orderDetailCreatedPhone: "",
        vehicleName: "",
        orderCreatedName: "",
        orderCreatedPhone: "",
        contractNo: "",
        startAddress: "",
        endAddress: "",
        weight: "",
        amount: "",
        goodsType: "",
        gmtCreated: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        balanceStart: "",
        balanceEnd: "",
        weightStart: "",
        weightEnd: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        sortField: "",
        sortType: "",
        loginkTarget: 0
      },
      // 上报
      isSendOptions: [
        { value: 0, label: "未上报" },
        { value: 1, label: "已上报" },
        { value: 2, label: "上报失败" }
      ],
      // 签章状态
      isSignOptions: [
        { value: 0, label: "未签章" },
        { value: 1, label: "已签章" }
      ],
      ModelSms: false,
      signType: ""
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.elecSignType();
    this.findList();
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    if (dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince) {
      this.loginkTarget =
        dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue;
    }
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/orderDetailContract",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    async PDFDownload(item) {
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要打印的项");
        return false;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return false;
      }
      let codes = [];
      for (let subItem of checkedRowArray) {
        codes.push(subItem.code);
      }
      codes = codes.join(",");
      const rLoading = this.openLoading("正在打包合同请稍后...");
      let response = await downLoadFile({ codes, isLocalHost: 0 });
      rLoading.close();
      this.$message.success(response.msg);
      window.open(response.data, "_blank");
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 获取详情
    funcDetail(path) {
      window.open(path);
    },
    //电子签章
    funcSign(code) {
      this.$confirm("确认进行电子签章？").then(_ => {
        request({
          url: `/ntocc-tps-api/elecSign/${code}`,
          method: "get"
        }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 重新签章
    async funcRebackSign(type, code) {
      let codes = "";
      if (type == 1) {
        const selectRecords = this.$refs.xTable.getSelectRecords();
        if (!selectRecords || selectRecords.length === 0) {
          return this.$message({ message: "请选择合同", type: "warning" });
        }
        if (selectRecords.length > 20) {
          return this.$message({
            message: "一次不能超过20条",
            type: "warning"
          });
        }
        codes = selectRecords.map(item => item.orderDetailCode).join(",");
      } else {
        codes = code;
      }
      const rLoading = this.openLoading();
      let res = await createContractAgain({ codes });
      rLoading.close();
      this.$message.success(res.msg);
      this.findList();
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.page = currentPage;
      this.listQuery.limit = pageSize;
      this.findList();
    },
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "平均";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.mean(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "和值";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    },
    // 上报
    reportLogink(c) {
      this.$confirm("确认上报监管平台吗？").then(_ => {
        const codes = c;
        const rLoading = this.openLoading();
        reportContractInfo({ codes })
          .then(response => {
            this.$message({ message: response.msg, type: "success" });
          })
          .finally(() => {
            this.$refs.xTable.clearCheckboxRow();
            this.findList();
            rLoading.close();
          });
      });
    },
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择合同", type: "warning" });
      } else {
        const codes = selectRecords.map(item => item.code).join(",");
        this.$confirm("确认上报监管平台吗？").then(_ => {
          const rLoading = this.openLoading();
          reportContractInfo({ codes })
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
            })
            .finally(() => {
              this.$refs.xTable.clearCheckboxRow();
              this.findList();
              rLoading.close();
            });
        });
      }
    },
    // 翻译
    formatterOptions({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    checCheckboxkMethod2({ row }) {
      return row.isSend != 1 && row.detailIsSend == 1;
    },
    //发送短信
    showModel(row, prefix) {
      this.$refs[`${prefix}Ref`].getInfo(row);
      this[`Model${prefix}`] = true;
    },
    hideModel() {
      this.ModelSms = false;
      this.findList();
    },
    close() {
      this.$refs.SmsRef.close();
    },
    //电子签章类型，0不使用e签宝，1使用e签宝短信
    elecSignType() {
      request({
        url: `/ntocc-tps-api/elecSign/type`,
        method: "get"
      }).then(response => {
        this.signType = response.data;
      });
    }
  }
};
</script>
